import React, { Component } from 'react';
import {
  NormalButton,
  PushButton,
} from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { OUTPUT_TTL } from '../../constants/Pac';

export const SwitchMode = {
  Momentary: 'Momentary',
  Maintain: 'Maintain',
  LatchOn: 'LatchOn',
};

@inject('batchStore')
@observer
class Switch extends Component {
  render() {
    const { device, batchStore } = this.props;
    const name = device.description || `Switch #${device.id}`;
    const on = batchStore.isOutputOn(device.onPNo);
    const off = batchStore.isOutputOn(device.offPNo);
    const onColor = device.onColor || '#00ff0f';
    const offColor = device.offColor || '#ff0000';
    let active = (device.statusPNo && !batchStore.isInputPortOff(device.statusPNo)) || on ? 'active' : '';

    if (device.mode === SwitchMode.Maintain) {
      const onTrigger = !batchStore.isInputPortOff(device.onTriggerPNo);
      const offTrigger = !batchStore.isInputPortOff(device.offTriggerPNo);

      if (active && device.offTriggerPNo && offTrigger) {
        active =  '';
      } else if (!active && device.onTriggerPNo && onTrigger) {
        active = 'active';
      }
    } else if (device.mode === SwitchMode.LatchOn) {
      const ds = batchStore.getDeviceStatus(device.id);
      active = ds.active
        ? 'active'
        : '';
    }

    const style = { backgroundColor: active ? onColor : offColor };
    const btnClassOn = on ? 'active' : '';
    const btnClassOff = off ? 'active btn-batch-red' : 'btn-batch-red';
    const duration = active ? 0 : OUTPUT_TTL;

    return (
      <div id={`device-${device.id}`} className={'device-gui device-gui--switch'}>
        <div className="device-label">
          <div className="device-type" title={`#${device.id}`}>{name}</div>
          <div className="status">{active ? device.onLabel || 'ON' : device.offLabel || 'OFF'}</div>
        </div>
        <div className="device-icon body" style={style}/>
        <div className="device-buttons">
          {device.mode === SwitchMode.Momentary
            ? (
              <div>
                {device.onPNo && (
                  <PushButton
                    className={`btn-batch ${btnClassOn}`}
                    port={device.onPNo}
                    disabled={batchStore.switchButtonShouldBeDisabled(device)}
                    onPush={() => batchStore.setOutput(device.onPNo, OUTPUT_TTL)}
                  >
                    <i className="fa fa-power-off" />
                  </PushButton>
                )}
                {device.offPNo && (
                  <PushButton
                    className={`btn-batch ${btnClassOff}`}
                    port={device.offPNo}
                    onPush={() => batchStore.setOutput(device.offPNo, OUTPUT_TTL)}
                  >
                    <i className="fa fa-power-off" />
                  </PushButton>
                )}
              </div>
            )
            : (
              <div>
                {device.onPNo && (
                  <NormalButton className={`btn-batch ${btnClassOn}`}
                    port={device.onPNo}
                    delay={on ? device.offDelay : device.onDelay}
                    duration={duration}
                    disabled={batchStore.switchButtonShouldBeDisabled(device)}
                  >
                    <i className="fa fa-power-off"/>
                  </NormalButton>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Switch);
